import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UnsubscribeList } from '@/pages/super-admin/unsubscribe-list';

const unsubscribeListSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(50),
	search: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/unsubscribe-list')({
	component: UnsubscribeList,
	validateSearch: unsubscribeListSearchSchema,
});
